"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get_1 = __importDefault(require("lodash/get"));
const DispatchContext_1 = require("../../../context/DispatchContext");
const EditableColumn_1 = __importDefault(require("../../../elements/EditableColumn"));
const formatNumber_1 = require("../../../utility/formatNumber");
const usePanelPreferences_1 = require("../../../hooks/usePanelPreferences");
function SignalDeltaColumn({ rowData, onHoverSignalX, onHoverSignalY, nucleus, }) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const nuclei = nucleus.split(',');
    const { deltaPPM: deltaX } = (0, usePanelPreferences_1.usePanelPreferences)('zones', nuclei[0]);
    const { deltaPPM: deltaY } = (0, usePanelPreferences_1.usePanelPreferences)('zones', nuclei[1]);
    const signalDeltaX = (0, get_1.default)(rowData, 'tableMetaInfo.signal.x.delta', null);
    const signalDeltaY = (0, get_1.default)(rowData, 'tableMetaInfo.signal.y.delta', null);
    const id = (0, get_1.default)(rowData, 'tableMetaInfo.signal.id', undefined);
    function saveXHandler(event) {
        const value = Number(event.target.value);
        dispatch({
            type: 'CHANGE_ZONE_SIGNAL_VALUE',
            payload: {
                zoneId: rowData.id,
                signal: { id, deltaX: value },
            },
        });
    }
    function saveYHandler(event) {
        const value = Number(event.target.value);
        dispatch({
            type: 'CHANGE_ZONE_SIGNAL_VALUE',
            payload: {
                zoneId: rowData.id,
                signal: { id, deltaY: value },
            },
        });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [deltaX.show && ((0, jsx_runtime_1.jsx)("td", { ...onHoverSignalX, children: signalDeltaX !== null ? ((0, jsx_runtime_1.jsx)(EditableColumn_1.default, { value: (0, formatNumber_1.formatNumber)(signalDeltaX, deltaX.format), onSave: saveXHandler, type: "number", style: { padding: '0.1rem 0.4rem' }, validate: (val) => val !== '' })) : ('') })), deltaY.show && ((0, jsx_runtime_1.jsx)("td", { ...onHoverSignalY, children: signalDeltaY !== null ? ((0, jsx_runtime_1.jsx)(EditableColumn_1.default, { value: (0, formatNumber_1.formatNumber)(signalDeltaY, deltaY.format), onSave: saveYHandler, type: "number", style: { padding: '0.1rem 0.4rem' }, validate: (val) => val !== '' })) : ('') }))] }));
}
exports.default = SignalDeltaColumn;
